"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _WU47XUXMcjs = require('./WU47XUXM.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/popover/popover-store.ts
var _popoverstore = require('@ariakit/core/popover/popover-store'); var Core = _interopRequireWildcard(_popoverstore);
function usePopoverStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.popover]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "placement");
  return _WU47XUXMcjs.useDialogStoreProps.call(void 0, store, update, props);
}
function usePopoverStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createPopoverStore, props);
  return usePopoverStoreProps(store, update, props);
}




exports.usePopoverStoreProps = usePopoverStoreProps; exports.usePopoverStore = usePopoverStore;
